import { defineMessages } from 'react-intl';

export const projectPagesMessages = defineMessages({
  projectNotFoundTitle: {
    defaultMessage: 'Project not found',
    id: 'zf+0a/YXti',
    description: 'Title when a Work project page cannot be loaded',
  },
  projectNotFoundBody: {
    defaultMessage:
      "This project may have been deleted, or the Projects API isn't deployed yet.",
    id: '8cuybWG+AH',
    description: 'Body copy when a Work project page cannot be loaded',
  },
  openSidebar: {
    defaultMessage: 'Open sidebar',
    id: 'um1k1w/WNZ',
    description: 'Aria label for opening the Work sidebar',
  },
});
